import {instance as axios} from "../helpers/axios.new";

const url = process.env.REACT_APP_LINK_HOST;

export const getWebhookData = (body) => {
  return axios.patch(`${url}/webhook/webhookData`, body);
};
